import React from 'react';
import { motion } from 'framer-motion';
import { HiOutlineChartBar, HiOutlineLightningBolt, HiOutlineShieldCheck, HiOutlineTrendingUp, HiOutlineChip, HiOutlineUserGroup } from 'react-icons/hi';
import './WhyChooseUs.css';

const WhyChooseUs = () => {
  const cards = [
    {
      title: 'Data-Driven Decisions',
      description: 'Every strategy is backed by real market data and technical insights.',
      icon: <HiOutlineChartBar className="wcu-icon" />,
      color: '#fc42ff' // Purple
    },
    {
      title: 'Built for Serious Traders',
      description: 'Designed for clarity, speed, and precision — not noise.',
      icon: <HiOutlineLightningBolt className="wcu-icon" />,
      color: '#42fcff' // Cyan
    },
    {
      title: 'Transparency First',
      description: 'No false promises, only clear and honest trading insights.',
      icon: <HiOutlineShieldCheck className="wcu-icon" />,
      color: '#10b981' // Emerald
    },
    {
      title: 'Consistent Performance',
      description: 'Focused on long-term growth, not short-term hype.',
      icon: <HiOutlineTrendingUp className="wcu-icon" />,
      color: '#f59e0b' // Amber
    },
    {
      title: 'Smart Technology',
      description: 'Advanced tools and analytics to give you an edge.',
      icon: <HiOutlineChip className="wcu-icon" />,
      color: '#f43f5e' // Rose
    },
    {
      title: 'Dedicated Support',
      description: 'Expert guidance to help you trade with confidence.',
      icon: <HiOutlineUserGroup className="wcu-icon" />,
      color: '#6366f1' // Indigo
    }
  ];

  return (
    <section className="why-choose-us-premium" id="features">
      <div className="wcu-background-glow"></div>
      <div className="container">
        <motion.div 
          className="wcu-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2>Why Traders Choose <span className="gradient-text-hero">Stocks4U</span></h2>
          <p>Built for performance, backed by strategy, and trusted by growing traders.</p>
        </motion.div>

        <div className="wcu-grid">
          {cards.map((card, index) => (
            <motion.div 
              key={index} 
              className="wcu-card"
              style={{ '--card-accent': card.color }}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <div className="wcu-card-icon">
                {card.icon}
              </div>
              <h3 className="wcu-card-title">{card.title}</h3>
              <p className="wcu-card-desc">{card.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
